import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  GetShortScenariosQuery,
  GetShortScenariosQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { shortScenarioFragment } from "src/graphql/anti-fraud/fragments/ShortScenarioFragment.ts";
import { useFetchQuery } from "src/graphql/utils";
import { mapToShortScenario } from "src/mappers/scenario.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getShortScenariosQuery = gql`
  query getShortScenarios($caseTypeCodes: [String!]) {
    scenarios(input: { caseTypeCodes: $caseTypeCodes }) {
      ...ShortScenarioFragment
    }
  }

  ${shortScenarioFragment}
` as TypedDocumentNode<GetShortScenariosQuery, GetShortScenariosQueryVariables>;

export const useGetShortScenariosQuery = (
  options?: QueryHookOptions<GetShortScenariosQuery, GetShortScenariosQueryVariables>
) => {
  return useFetchQuery(getShortScenariosQuery, {
    queryOptions: options,
    toData: (data) => data?.scenarios?.map(mapToShortScenario) ?? [],
    isEmpty: (data) => isEmpty(data?.scenarios),
    uiErrors: { fetchError: "FETCH-SCENARIOS-ERROR" },
  });
};
